import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { loadConfig } from "./api.js";
import { OKTA_ENABLED, oktaAuth } from "./auth/okta.js";
import Dashboard from "./pages/Dashboard.jsx";
import ServiceDetail from "./pages/ServiceDetail.jsx";
import RunDetail from "./pages/RunDetail.jsx";
import LoginCallback from "./pages/LoginCallback.jsx";

function AuthGate({ children }) {
  const [ready, setReady] = useState(!OKTA_ENABLED);
  const navigate = useNavigate();

  useEffect(() => {
    if (!OKTA_ENABLED) return;

    let cancelled = false;
    (async () => {
      const auth = await oktaAuth.isAuthenticated();
      if (cancelled) return;
      if (!auth) {
        await oktaAuth.signInWithRedirect();
        return;
      }
      setReady(true);
    })().catch(() => navigate("/"));

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (!ready) return <p>Checking session…</p>;
  return children;
}

export default function App() {
  const [cfgError, setCfgError] = useState(null);
  const [cfgReady, setCfgReady] = useState(false);

  useEffect(() => {
    loadConfig()
      .then(() => setCfgReady(true))
      .catch((e) => setCfgError(String(e.message || e)));
  }, []);

  if (cfgError) {
    return (
      <main>
        <div className="error">Config: {cfgError}</div>
      </main>
    );
  }

  if (!cfgReady) {
    return (
      <main>
        <p>Loading configuration…</p>
      </main>
    );
  }

  return (
    <>
      <header className="nav">
        <a href="/">Integration Tests</a>
      </header>
      <main>
        <Routes>
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route
            path="/"
            element={
              <AuthGate>
                <Dashboard />
              </AuthGate>
            }
          />
          <Route
            path="/services/:serviceName"
            element={
              <AuthGate>
                <ServiceDetail />
              </AuthGate>
            }
          />
          <Route
            path="/runs/:runId"
            element={
              <AuthGate>
                <RunDetail />
              </AuthGate>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}
